import Footer from "./components/Footer";

export default {
  "extensions/afrux-theme-base/forum/components/Footer": Footer,
};
